import enMessages from '../locales/en-us.json';

const EnLang = {
	messages: {
		...enMessages
	},
	locale: 'en-US'
};
export default EnLang;
